import styled from 'styled-components';
import {shadows, colors} from '../../styleVariables';

/*
 * Mesmo padrão visual do cabeçalho do modal de resultado de relatório no mapa
 * (src/components/reactTable/style.js: .header) -- fundo branco, texto na cor da central, borda
 * gray5, canto superior arredondado, sombra leve. Aqui o cabeçalho é um <thead> real (react-bootstrap-table
 * gera header/body como duas tabelas separadas, sincronizadas por largura), então o alvo é
 * `.react-bs-container-header thead th` em vez de um `.header` de flex row.
 */
export const ThemedTableWrapper = styled.div`
  .react-bs-container-header {
    border: 1px solid ${colors.gray5};
    border-top-left-radius: 12px;
    border-top-right-radius: 12px;
    overflow: hidden;
    box-shadow: ${shadows.shadow};

    thead tr th {
      background-color: white;
      color: ${(props) => props.theme};
      font-weight: bold;
      // Título à esquerda, como a lib grava inline por coluna (TableHeaderColumn) --
      // !important só pra vencer qualquer regra de classe sem depender da ordem do CSS.
      text-align: left !important;
      border: none;
    }
  }

  // Sem linhas, a lib centraliza o aviso numa célula que ocupa a tabela inteira; com a tabela mais
  // larga que o card o texto cai fora da área visível, então fica à esquerda.
  .react-bs-container-body td.react-bs-table-no-data {
    text-align: left;
  }

  // Largura calculada (helpers/columnWidth.js) já mede o texto exato -- nowrap+ellipsis é só
  // rede de segurança pro caso raro em que outro valor da lista, mais largo que o medido nesta
  // amostra, apareça ao rolar/filtrar. Sem isso quebraria linha em vez de cortar com reticência.
  .react-bs-container-header thead tr th,
  .react-bs-container-body td {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;
